import * as tus from 'tus-js-client'

export interface ResumableVimeoUploadOptions {
  onProgress?: (loaded: number, total: number) => void
}

const CHUNK_SIZE_BYTES = 128 * 1024 * 1024

export class ResumableVimeoUpload {
  private readonly upload: tus.Upload

  constructor(file: File, uploadUrl: string, options?: ResumableVimeoUploadOptions) {
    this.upload = new tus.Upload(file, {
      endpoint: uploadUrl,
      uploadUrl,
      chunkSize: CHUNK_SIZE_BYTES,
      retryDelays: [0, 3000, 5000, 10000, 20000],
      overridePatchMethod: false,
      removeFingerprintOnSuccess: true,
      metadata: {
        filename: file.name,
        filetype: file.type,
      },
      onProgress: (bytesUploaded, bytesTotal) => options?.onProgress?.(bytesUploaded, bytesTotal),
    })
  }

  start(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.upload.options.onSuccess = () => resolve()
      this.upload.options.onError = error => reject(error)
      this.upload.start()
    })
  }

  pause(): void {
    this.upload.abort()
  }

  resume(): void {
    this.upload.start()
  }
}

export const extractVimeoId = (playerEmbedUrl: string, vimeoBaseUrl?: string): string =>
  vimeoBaseUrl ? playerEmbedUrl.replace(`${vimeoBaseUrl}/`, '') : playerEmbedUrl.split('/').pop() ?? ''
